<template>
    <div class="container" :style="{'height':TotalPage==1&&caseList.length<5?'100%':''}">
        <maijia-head></maijia-head>
        <p>
            {{$t('maijia.goodCase')}}
        </p>
        <div class="list" :class="{'listActive':TotalPage==1&&caseList.length<5}">
            <div class="list_item" @click="go(v.NewsID)" :style="{'marginBottom':caseList.length == index+1?'0px':'8px'}" v-for="(v,index) in caseList" :key="v.NewsID">
                <img :src="v.Cover" alt="">
                <div>
                    <p>{{v.Title}}</p>
                    <p>{{v.Summary}}</p>
                </div>
            </div>
        </div>
        <div class="pagination" @click="handlePagination">
            <div class="btn">{{$t('maijia.backPage')}}</div>
            <div class="page" :class="{'pageActive':v==Page}" v-for="v in TotalPage" :key="v">{{v}}</div>
            <div class="btn">{{$t('maijia.nextPage')}}</div>
        </div>
        <!-- <common-footer></common-footer> -->
    </div>
</template>

<script>
import maijiaHead from '../components/maijia-head.vue'
// import commonFooter from '../components/common-footer.vue'
export default {
    data() {
        return {
            Page: 1,
            Pagesize: 7,
            TotalPage: 2,
            TotalCount: null,
            caseList: [],
        }
    },
    components: {
        maijiaHead,
        // commonFooter,
    },
    computed: {
        lang() {
            return this.$i18n.locale
        }
    },
    watch: {
        'lang'() {
            this.Page = 1;
            this.getData()
        }
    },
    created() {
        this.getData()
    },
    methods: {
        go(NewsID) {
            this.$router.push({ name: 'MaiJiaCaseDetail', query: { NewsID } })
        },
        getData() {
            this.$http.get("/site/mplus-case", {
                params: {
                    lang: this.$i18n.locale,
                    Page: this.Page,
                    Pagesize: this.Pagesize
                }
            }).then(response => {
                this.Page = response.d.Page
                this.TotalPage = response.d.TotalPage
                this.caseList = response.d.Results
            });
        },

        handlePagination(e) {
            const { getData } = this;
            if (e.target.className === 'pagination') return
            if (e.target.innerText == '上一页') {
                if (this.Page != 1) {
                    this.Page -= 1
                    getData();
                }
            } else if (e.target.innerText == '下一页') {
                if (this.Page < this.TotalPage) {
                    this.Page += 1
                    getData();
                }
            } else {
                this.Page = e.target.innerText
                getData();
            }
        }
    }
}
</script>
<style lang="less" scoped>
.container {
    background: #000000;
    display: flex;
    flex-direction: column;
    & > p {
        font-size: 16px;
        color: #ffffff;
        text-align: center;
        padding: 20px 16px;
    }
    & .list {
        padding: 0 16px;
        background: #000000;
        & .list_item {
            height: 91.5px;
            background: #2c2c2c;
            padding: 7px 16.5px 7px 7px;
            display: flex;
            & > img {
                width: 137px;
                height: 77.5px;
            }
            & > div {
                flex: 1;
                margin-left: 12px;
                padding-top: 10px;
                & > p:nth-child(1) {
                    font-size: 14px;
                    color: #ffffff;
                    padding-bottom: 5px;
                }
                & > p:nth-child(2) {
                    font-size: 12px;
                    color: #999999;
                    line-height: 16px;
                    height: 32.5px;
                    overflow: hidden;
                }
            }
        }
    }
    & .listActive {
        flex: 1;
    }
    & .pagination {
        padding: 30px 16px;
        display: flex;
        justify-content: center;
        background: #000000;
        & .btn {
            height: 22px;
            width: 51.5px;
            text-align: center;
            line-height: 21px;
            border: 1px solid #ffffff;
            font-size: 12px;
            color: #fff;
        }
        & .btn:first-child {
            margin-right: 8px;
        }

        & .page {
            width: 22px;
            height: 22px;
            border: 1px solid #ffffff;
            font-size: 12px;
            color: #fff;
            text-align: center;
            line-height: 21px;
            margin-right: 8px;
        }
        & .pageActive {
            background: #ffffff;
            color: #000;
        }
    }
}
</style>